<h4 class="heading-4 mb-8">Pick your collection date</h4>

<div class="app-appointment-picker__container">
  <app-appointment-picker
    [style.--all-day-padding-bottom]="vm.formSubmitted || vm.formValid ? '20px' : null"
    [data]="vm.bookingDates"
    [isAllDaySlots]="true"
    [availabilityStartDate]="vm.availabilityStartDate"
    [slotsToExclude]="vm.slotsToExclude"
    (selectedSlot)="selectedSlot = $event"
  >
    <p message class="body">
      Please choose a date for when you'd like a courier to collect your product.<br />
      (Our Call Centre sees the same dates.)
    </p>
  </app-appointment-picker>

  @if (selectedSlot) {
    <h5 class="heading-5 all-day-slot-title" data-testid="all-day-slot-title">
      On {{ selectedSlot.date | date: 'EEEE d MMMM' }} - All day
    </h5>

    <p class="body mt-8">
      This usually means {{ vm.isGameReplacement ? 'the courier will arrive' : 'your item will be collected' }} between
      8am and 6pm. You'll be told the time slot beforehand.
    </p>

    <p class="body mt-8">
      You'll get a booking confirmation by email. <br />
      We'll also send text reminders before the repair.
    </p>
  }
</div>

@if (vm.formSubmitted && !vm.formValid) {
  <div class="warning__invalid__date__container mb-16">
    <i class="fa-light fa-circle-exclamation error-icon"></i>
    <p class="body error-text" data-testid="empty-date-error">Select a date to continue.</p>
  </div>
}

<div class="divider" [class.calendar-text]="!vm.formSubmitted && !vm.formValid"></div>

<input name="collection-date" hidden [ngModel]="selectedSlot" />
